import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsFilter = _resolveComponent("StatisticsFilter")!

  return (_openBlock(), _createBlock(_component_StatisticsFilter, {
    filtersConfig: _ctx.getFiltersConfig,
    onSearchFilter: _ctx.searchFilter,
    onUpdateFilter: _ctx.updateFilter
  }, null, 8, ["filtersConfig", "onSearchFilter", "onUpdateFilter"]))
}